// import { PageHeader } from "@ant-design/pro-layout";
import { useParams } from "react-router-dom";
import { getItem } from "../../../../../../../shared/local-storage";
import { SummaryContainer } from "../summary.container";


export const ArchiveSummary: React.FC = () => {

  const params = useParams();
  const applicantUserId = getItem('applicantUserId');

  return (
    <SummaryContainer data={{ caseId: params.caseId ?? "", applicantId: applicantUserId ?? "" }} />
  );
};
